import $ from 'jquery';

export class DOMDataCache {
  constructor() {
    this.cache = {};
  }

  /**
   * 從快取中獲取一個值。
   * @param {string} key - 快取的鍵。
   * @returns {*} - 返回快取的值，如果不存在則返回 undefined。
   */
  get(key) {
    return this.cache[key];
  }

  /**
   * 獲取一個 DOM 元素。如果快取中不存在，則查詢 DOM 並存入快取。
   * @param {string} selector - jQuery 選擇器。
   * @param {jQuery} [$context=null] - (可選) 查詢的上下文。
   * @returns {jQuery|null} - 返回 jQuery 物件或 null。
   */
  getOrSetElement(selector, $context = null) {
    if (this.has(selector)) {
      return this.get(selector);
    }

    const $element = $context ? $context.find(selector) : $(selector);

    if ($element.length) {
      this.set(selector, $element);
      return $element;
    }

    return null;
  }

  set(key, value) {
    this.cache[key] = value;
  }

  has(key) {
    return this.cache.hasOwnProperty(key);
  }
}